import { render, staticRenderFns } from "./CommonSwitch.vue?vue&type=template&id=5ba2be6c&scoped=true"
import script from "./CommonSwitch.vue?vue&type=script&lang=js"
export * from "./CommonSwitch.vue?vue&type=script&lang=js"
import style0 from "./CommonSwitch.vue?vue&type=style&index=0&id=5ba2be6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba2be6c",
  null
  
)

export default component.exports